import { linkReplace } from '@loomhq/loom-embed';
import React, { useEffect, useRef } from 'react';

import { INLINE_COMMENT_LOOM_VIDEO_SELECTOR } from 'constants/comments';
import { sanitizeContent } from 'utilities/comments';

import styles from './styles.module.less';

const PostBody = props => {
  const { content } = props;

  const postRef = useRef();

  // replace Loom links with video embeds
  useEffect(() => {
    postRef.current &&
      linkReplace(INLINE_COMMENT_LOOM_VIDEO_SELECTOR, {}, postRef.current);
  }, []);

  return (
    <div
      ref={postRef}
      className={styles.postBody}
      dangerouslySetInnerHTML={{ __html: sanitizeContent(content) }}
    />
  );
};

export default PostBody;
